import * as angular from 'angular';

class CapacityLinkingReportOverviewCtrl implements ng.IController {
    $onInit(): void {}
}

angular.module('app').component('pkpCapacityLinkingReportOverview', {
    controller: CapacityLinkingReportOverviewCtrl,
    template:
        require('app/capacity-linking-reporting/capacity-linking-report-overview.component.html'),
    bindings: {}
});
